/* unplugin-vue-components disabled */import { render } from "./HamsterCard.vue?vue&type=template&id=4c8fac48&scoped=true"
import script from "./HamsterCard.vue?vue&type=script&lang=js"
export * from "./HamsterCard.vue?vue&type=script&lang=js"

import "./HamsterCard.vue?vue&type=style&index=0&id=4c8fac48&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c8fac48"]])

export default __exports__